<!--
 * @Description: 商机表单卡片
 * @Author: mdb
 * @Date: 2022-07-01 16:10:071
 * @LastEditTime: 2023-02-17 14:11:10
 * @LastEditors: cxh
-->
<template>
  <a-form scrollToFirstError>
    <dc-layout-card :title="props.title" :span="6">
      <dc-form-item label="客户名称" v-bind="validateInfos.saleChanceRefId">
        <ClueAndCustomerSelect
          appId="cos_fbu"
          v-model:value="dataForm.saleChanceRefId"
          v-model:label="dataForm.customerName"
          :disabled="!isEdit || props.saleChanceRefId || !isAddOrCopy"
          :view="props.type === 'view'"
          placeholder="请选择客户名称"
          @change="handleCustomerNameChange"
        />
      </dc-form-item>
      <dc-form-item label="子客户代码" v-bind="validateInfos.arkCodeId">
        <GcCodeSelect
          :cosId="dataForm.saleChanceRefId"
          v-model:label="dataForm.arkCode"
          v-model:value="dataForm.arkCodeId"
          v-model:isEmpty="isEmptyCustomer"
          :disabled="!isEdit || props.arkCodeId || ((originalStatus>4&&originalStatus!=6)&&!isAddOrCopy)"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="商机类型" v-bind="validateInfos.chanceType">
        <ParamCodesSelect
          v-model:value="dataForm.chanceType"
          :options="paramCodeData.fbu_chance_type"
          :disabled="!isEdit || !isAddOrCopy"
          :view="props.type === 'view'"
          allowClear
          @change="changeTypeChangeEvent"
        />
      </dc-form-item>
      <dc-form-item label="订单类型" v-bind="validateInfos.orderType">
        <CosSelect
          v-model:value="dataForm.orderType"
          :options="orderTypeEnum"
          :disabled="!isEdit || !isAddOrCopy"
          :view="props.type === 'view'"
          allowClear
          @change="handleOrderTypeChange"
        />
      </dc-form-item>
      <template v-if="isHeadOd">
        <dc-form-item label="中转仓" v-bind="validateInfos.headDomesticWarehouse">
          <ParamCodesSelect
            v-model:value="dataForm.headDomesticWarehouse"
            :options="paramCodeData.fbu_head_domestic_warehouse"
            :disabled="!isEdit || !isAddOrCopy"
            :view="props.type === 'view'"
            allowClear
          />
        </dc-form-item>
        <dc-form-item label="目的国仓库" v-bind="validateInfos.headDestinationCountryWarehouse">
          <ParamCodesSelect
            v-model:value="dataForm.headDestinationCountryWarehouse"
            :options="paramCodeData.fbu_head_destination_country_warehouse"
            :disabled="!isEdit || !isAddOrCopy"
            :view="props.type === 'view'"
            allowClear
          />
        </dc-form-item>
        <dc-form-item label="运输方式" v-bind="validateInfos.headTransportMode">
          <ParamCodesSelect
            v-model:value="dataForm.headTransportMode"
            :options="paramCodeData.fbu_head_replenish_method"
            :disabled="!isEdit || !isAddOrCopy"
            :view="props.type === 'view'"
            allowClear
          />
        </dc-form-item>
        <dc-form-item label="头程竞争对手" v-bind="validateInfos.headCompetitors">
          <ParamCodesSelect
            v-model:value="dataForm.headCompetitors"
            :options="paramCodeData.fbu_head_competitors"
            :view="props.type === 'view'"
            allowClear
            mode="multiple"
            :max-tag-count="!isEdit ? 100 : 'responsive'"
          />
        </dc-form-item>
      </template>
      <template v-if="istailOd">
        <dc-form-item label="尾程仓库名称" v-bind="validateInfos.tailWarehouse">
          <ParamCodesSelect
            v-model:value="dataForm.tailWarehouse"
            :options="paramCodeData.fbu_tail_warehouse_name"
            :disabled="!isEdit || !isAddOrCopy"
            :view="props.type === 'view'"
            allowClear
            @change="handleTailWarehouseChange"
          />
        </dc-form-item>
        <dc-form-item label="物流产品" v-bind="validateInfos.tailProductName">
          <CosSelect
            v-model:value="dataForm.tailProductName"
            :disabled="!isEdit || !isAddOrCopy"
            :options="logisticsProductsEnum"
            allowClear
            :view="props.type === 'view'"
          />
        </dc-form-item>
        <dc-form-item label="尾程竞争对手" v-bind="validateInfos.tailCompetitors">
          <ParamCodesSelect
            v-model:value="dataForm.tailCompetitors"
            :options="paramCodeData.fbu_warehouse"
            :view="props.type === 'view'"
            allowClear
            mode="multiple"
            :max-tag-count="!isEdit ? 100 : 'responsive'"
          />
        </dc-form-item>
      </template>
      <dc-form-item label="预计月销售额(万)" v-bind="validateInfos.planSaleAmount">
        <CosInputNumber
          style="width: 100%"
          :min="0"
          :maxlength="15"
          v-model:value="dataForm.planSaleAmount"
          :disabled="!isEdit || (originalStatus>6&&!isAddOrCopy)"
          placeholder="对应仓库及渠道的预计月销售额"
          :view="props.type === 'view'"
          oninput="value=value.replace(/[^\d.]/g,'')"
        />
      </dc-form-item>
      <dc-form-item label="商机状态" v-bind="validateInfos.status">
        <template #label>
          商机状态
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <div v-for="item in businessStatusEnumFilter" :key="item.value">
                <p>{{ item.label }}{{ item.desc ? `：${item.desc}` : '' }}</p>
              </div>
            </template>
            <ExclamationCircleOutlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSelect
          v-model:value="dataForm.status"
          :options="businessStatusEnumFilter"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item label="预计达成时间" v-bind="validateInfos.planSignTime">
        <CosSingleDateTimePicker
          v-model:startTime="dataForm.planSignTime"
          :isRange="false"
          :disabled="!isEdit || ((originalStatus>4&&originalStatus!=6)&&!isAddOrCopy)"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="达成时间" v-if="props.type === 'view'||props.type === 'edit'||(isAddOrCopy && dataForm.reachTime)">
        <CosInput
          v-model:value.trim="dataForm.reachTime"
          :maxlength="200"
          :disabled="true"
          placeholder="--"
          :view="props.type === 'view'"/>
      </dc-form-item>
      <dc-form-item label="完结时间" v-if="props.type === 'view'||props.type === 'edit'">
        <CosInput
          v-model:value.trim="dataForm.overTime"
          :maxlength="200"
          :disabled="true"
          placeholder="--"
          :view="props.type === 'view'"/>
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="备注" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="!isEdit || (originalStatus>6&&!isAddOrCopy)"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, watch, watchEffect, toRaw, computed } from 'vue'
import { cloneDeep, isEqual } from 'lodash-es'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import GcCodeSelect from '@/components/GcCodeSelect'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import { selectForNumberValidate } from '@/utils/validate'
import { Form } from 'ant-design-vue'
import { businessStatusEnum, orderTypeEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { paramCodesDataFilter } from '@/utils'
import type { ParamCodeItem } from '@/typings/common'
import type { SelectProps } from 'ant-design-vue'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
import { getLastChance } from '@/api/gucangSales/chanceManage'
const useForm = Form.useForm
const props = defineProps<{
  value: { [key: string]: any }
  title?: string

  type: 'add' | 'edit' | 'view'|'copy'
  saleChanceRefId?: boolean
  originalStatus?:number
  arkCodeId?: boolean
  isFromPotentialCustomer?: boolean
}>()
onMounted(() => {
  getByParamCodes()
})
const businessStatusEnumFilter = ref<any[]>()
const isEdit = computed(() => props.type !== 'view')
const isAddOrCopy = computed(() => (props.type === 'add' || props.type === 'copy'))
const logisticsProductsEnum = ref<SelectProps['options']>([])
const paramCodeData = ref<{
  fbu_chance_type: ParamCodeItem[]
  fbu_head_domestic_warehouse: ParamCodeItem[]
  fbu_head_destination_country_warehouse: ParamCodeItem[]
  fbu_head_replenish_method: ParamCodeItem[]
  fbu_head_competitors: ParamCodeItem[]
  fbu_tail_warehouse_name: ParamCodeItem[]
  fbu_warehouse: ParamCodeItem[]
}>({
  fbu_chance_type: [], // 商机类型
  fbu_head_domestic_warehouse: [], // 国内仓库
  fbu_head_destination_country_warehouse: [], // 目的国仓库
  fbu_head_replenish_method: [], // 运输方式
  fbu_head_competitors: [], // 头程竞争对手
  fbu_tail_warehouse_name: [], // 尾程仓库名称
  fbu_warehouse: [] // 尾程竞争对手（目前合作海外仓）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_chance_type',
      'fbu_head_domestic_warehouse',
      'fbu_head_destination_country_warehouse',
      'fbu_head_replenish_method',
      'fbu_head_competitors',
      'fbu_tail_warehouse_name',
      'fbu_warehouse'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
const dataForm = reactive<FbuBusinessEditParams>({
  customerName: undefined,
  saleChanceRefId: undefined,
  arkCodeId: undefined,
  planSaleAmount: undefined,
  status: undefined,
  remark: undefined,
  chanceType: undefined,
  orderType: undefined,
  planSignTime: undefined,
  headDomesticWarehouse: undefined,
  headDestinationCountryWarehouse: undefined,
  headTransportMode: undefined,
  headCompetitors: undefined,
  tailWarehouse: undefined,
  tailProductName: undefined,
  tailCompetitors: undefined
})
/// 上个商机的月均预计销售额
const lastPlanSaleAmount = ref<number>()

const emit = defineEmits(['update:value', 'planSaleAmount'])
watch(
  () => props.value,
  (val) => {
    if (!val) return
    // 如果值相同则不更新
    const isSame = isEqual(toRaw(dataForm), toRaw(val))
    if (isSame) return
    const clone = cloneDeep(val)
    Object.assign(dataForm, clone)
    if (props.type === 'view') {
      setTimeout(() => clearValidate())
    }
  },
  { deep: true, immediate: true }
)
// const businessStatusEnumFilter = computed(() => {
//   return businessStatusEnum.map((item) => ({ ...item, disabled: (props.type === 'add' || props.type === 'copy') && item.value === 6 }))
// })
watch(() => props.originalStatus,
  (val) => {
    const currentStatus = props.originalStatus
    if (!currentStatus) {
      return
    }
    switch (props.type) {
      case 'view':
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus)
        break
      case 'copy':
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 5)
        break
      case 'add':
      case 'edit':
        if (currentStatus < 4) {
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus || item.value === currentStatus + 1 || item.value === currentStatus + 2 || item.value === 6)
        } else if (currentStatus === 4) {
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus || item.value === 6)
        } else if (currentStatus === 6) {
          /// 未能合作商机，支持可以修改商机状态为【初步接洽】、【确认需求】、【制定方案】
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value < 5 || item.value === 6)
        } else {
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus)
        }
        break
    }
  })
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)
watch(
  lastPlanSaleAmount,
  (val) => {
    emit('planSaleAmount', val)
  },
  { deep: true }
)

const isHeadOd = ref<boolean>()
const istailOd = ref<boolean>()
const isRequiredCustomer = ref<boolean>()
const isEmptyCustomer = ref<boolean>()
watchEffect(() => {
  // 监听订单类型，切换不同表单项
  if (dataForm.orderType === 1) {
    isHeadOd.value = true
    istailOd.value = false
  } else if (dataForm.orderType === 2) {
    istailOd.value = true
    isHeadOd.value = false
  } else {
    isHeadOd.value = undefined
    istailOd.value = undefined
  }

  // 监听尾程仓库名称变化，更新物流产品数据
  if (dataForm.tailWarehouse) {
    const find = paramCodeData.value.fbu_tail_warehouse_name.find((item) => item.id === dataForm.tailWarehouse)
    if (find?.children && find.children.length > 0) {
      logisticsProductsEnum.value = find.children.map((item) => ({
        label: item.name,
        value: item.id
      }))
    } else {
      logisticsProductsEnum.value = []
    }
  }
})

// 监听是否转潜在客户(客户代码非必填)
// 监听有客户代码数据时则必选
watch(
  [props.isFromPotentialCustomer, isEmptyCustomer],
  ([isFromPotential, isEmptyCustomer]) => {
    if (isFromPotential || isEmptyCustomer) {
      isRequiredCustomer.value = false
    } else {
      isRequiredCustomer.value = true
    }
    if (props.type === 'edit' || props.type === 'view') {
      setTimeout(() => clearValidate(['arkCodeId']), 0)
    }
  },
  { immediate: true }
)
const changeTypeChangeEvent = (value: any) => {
  console.log(value)
  if (!value) {
    return
  }
  /// 这里进判断新增和复制的时候来切换商机状态列表
  if (isAddOrCopy.value) {
    /// 新商机
    if (value === 398) {
      dataForm.status = 1
      businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 1)
    } else if (value === 399) {
      dataForm.status = 5
      businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 5)
    }
  }
}
const handleTailWarehouseChange = (value: any) => {
  dataForm.tailProductName = undefined
  setTimeout(() => clearValidate(['tailProductName']), 0)
}
const handleCustomerNameChange = () => {
  setTimeout(() => clearValidate(['arkCodeId']), 0)
}
const formRules = reactive({
  saleChanceRefId: [{ required: true, message: '请选择客户名称' }],
  arkCodeId: [{ required: isRequiredCustomer, message: '请选择子客户代码' }],
  planSaleAmount: [{ required: true, message: '请输入预计月销售额' }],
  status: [{ required: true, validator: selectForNumberValidate, message: '请选择商机状态' }],
  chanceType: [{ required: true, validator: selectForNumberValidate, message: '请选择商机类型' }],
  orderType: [{ required: true, validator: selectForNumberValidate, message: '请选择订单类型' }],
  planSignTime: [{ required: true, message: '请选择预计达成时间' }],
  headDomesticWarehouse: [{ required: isHeadOd, validator: selectForNumberValidate, message: '请选择中转仓' }],
  headDestinationCountryWarehouse: [
    { required: isHeadOd, validator: selectForNumberValidate, message: '请选择目的国仓库' }
  ],
  headTransportMode: [{ required: isHeadOd, validator: selectForNumberValidate, message: '请选择运输方式' }],
  headCompetitors: [{ required: isHeadOd, message: '请选择头程竞争对手' }],
  tailWarehouse: [{ required: istailOd, validator: selectForNumberValidate, message: '请选择尾程仓库名称' }],
  tailProductName: [{ required: istailOd, validator: selectForNumberValidate, message: '请选择尾程物流产品名称' }],
  tailCompetitors: [{ required: istailOd, message: '请选择尾程竞争对手' }]
})
const { resetFields, validate, validateInfos, clearValidate } = useForm(dataForm, formRules)
const handleOrderTypeChange = (value: any) => {
  if (value === 1) {
    dataForm.tailWarehouse = undefined
    dataForm.tailProductName = undefined
    dataForm.tailCompetitors = undefined
  } else if (value === 2) {
    dataForm.headDomesticWarehouse = undefined
    dataForm.headDestinationCountryWarehouse = undefined
    dataForm.headTransportMode = undefined
    dataForm.headCompetitors = undefined
  } else {
    dataForm.headDomesticWarehouse = undefined
    dataForm.headDestinationCountryWarehouse = undefined
    dataForm.headTransportMode = undefined
    dataForm.headCompetitors = undefined

    dataForm.tailWarehouse = undefined
    dataForm.tailProductName = undefined
    dataForm.tailCompetitors = undefined
  }
  clearValidate([
    'headDomesticWarehouse',
    'headDestinationCountryWarehouse',
    'headTransportMode',
    'headCompetitors',
    'tailWarehouse',
    'tailProductName',
    'tailCompetitors'
  ])
}
/// 定义一个监听其他表单数据填写后查询达成时间的值
const couldFetchReachTimeStateComputed = computed(() => {
  if (isAddOrCopy.value) {
    if (!dataForm.arkCodeId) {
      return undefined
    }
    if (dataForm.orderType === 1) {
      if (!dataForm.headDomesticWarehouse) {
        return undefined
      }
      if (!dataForm.headDestinationCountryWarehouse) {
        return undefined
      }
      if (!dataForm.headTransportMode) {
        return undefined
      }
      return {
        arkCodeId: dataForm.arkCodeId,
        orderType: 1,
        headDomesticWarehouse: dataForm.headDomesticWarehouse,
        headDestinationCountryWarehouse: dataForm.headDestinationCountryWarehouse,
        headTransportMode: dataForm.headTransportMode
      }
    } else if (dataForm.orderType === 2) {
      if (!dataForm.tailWarehouse) {
        return undefined
      }
      if (!dataForm.tailProductName) {
        return undefined
      }
      return {
        arkCodeId: dataForm.arkCodeId,
        orderType: 2,
        tailWarehouse: dataForm.tailWarehouse,
        tailProductName: dataForm.tailProductName
      }
    }
  }
  return undefined
})
watch(() => couldFetchReachTimeStateComputed.value,
  (val) => {
    if (!couldFetchReachTimeStateComputed.value) {
      dataForm.chanceType = undefined
      dataForm.status = undefined
      businessStatusEnumFilter.value = []
      lastPlanSaleAmount.value = undefined
      return
    }
    getLastChance(couldFetchReachTimeStateComputed.value).then((res) => {
      if (res.data) {
        const lastStatus = res.data?.status
        /// 当获取到的上一条商机为未能合作或者关闭时 则显示为新商机
        if (lastStatus === 6 || lastStatus === 8) {
          lastPlanSaleAmount.value = undefined
          dataForm.chanceType = 398
          dataForm.status = 1
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 1)
        } else {
          lastPlanSaleAmount.value = res.data?.planSaleAmount
          dataForm.chanceType = 399
          dataForm.status = 5
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 5)
        }
      } else { /// 新商机
        lastPlanSaleAmount.value = undefined
        dataForm.chanceType = 398
        dataForm.status = 1
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 1)
      }
      dataForm.reachTime = res.data?.reachTime || undefined
    })
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // .finally(() => {})
  }
)
defineExpose({ resetFields, validate, clearValidate })
</script>
<script lang="ts">
export default { name: 'BusinessForm' }
</script>

<style scoped></style>
